// extracted by mini-css-extract-plugin
export default {"emailTurnedOffNotification":"HandlerAssignmentNotificationEmailEditorDialog_emailTurnedOffNotification__-kxVC"};